import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Pricing.css';

const features = [
  'Unlimited surveys',
  'Real-time dashboards',
  'Team & company analytics',
  'Anonymous responses',
  'Mobile app access (iOS & Android)',
  'PDF report generation',
  'Email support',
];

const CheckIcon = () => (
  <span className="check-icon-wrap">
    <svg viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
    </svg>
  </span>
);

function Pricing() {
  return (
    <section className="pricing" id="pricing">
      <div className="section-container">
        <div className="pricing-card">
          <div className="price-header">
            <h3>Everything You Need</h3>
            <div className="price">
              <span className="currency">£</span>
              <span className="amount">5</span>
              <span className="period">/employee/month</span>
            </div>
          </div>

          <ul className="price-features">
            {features.map((f) => (
              <li key={f}>
                <CheckIcon />
                {f}
              </li>
            ))}
          </ul>

          <Link to="/signup" className="btn-primary">Start free trial</Link>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
